/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';
import { Children as ChildrenPropTypes } from '@instructure/ui-prop-types';
import { Drilldown } from '@instructure/ui-drilldown';
const topNavBarItemTooltipPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  renderTip: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  color: PropTypes.oneOf(['primary', 'primary-inverse']),
  placement: PropTypes.string,
  offsetX: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  offsetY: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onShowContent: PropTypes.func,
  onHideContent: PropTypes.func
})]);
const propTypes = {
  id: PropTypes.string.isRequired,
  as: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['default', 'button', 'icon', 'avatar']),
  status: PropTypes.oneOf(['default', 'active', 'disabled']),
  renderSubmenu: ChildrenPropTypes.oneOf([Drilldown]),
  showSubmenuChevron: PropTypes.bool,
  customPopoverConfig: PropTypes.object,
  tooltip: topNavBarItemTooltipPropType,
  renderAvatar: PropTypes.shape({
    avatarName: PropTypes.string.isRequired,
    avatarSrc: PropTypes.string,
    avatarAlt: PropTypes.string
  }),
  renderIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  href: PropTypes.string,
  onClick: PropTypes.func,
  onHiddenClick: PropTypes.func,
  onSubmenuToggle: PropTypes.func,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  elementRef: PropTypes.func,
  itemRef: PropTypes.func,
  shouldCloseOnClick: PropTypes.oneOf(['auto', 'always', 'never']),
  withFocusOutline: PropTypes.bool
};
const allowedProps = ['id', 'as', 'children', 'variant', 'status', 'renderSubmenu', 'showSubmenuChevron', 'customPopoverConfig', 'tooltip', 'renderAvatar', 'renderIcon', 'href', 'onClick', 'onHiddenClick', 'onSubmenuToggle', 'onMouseOver', 'onMouseOut', 'onFocus', 'onBlur', 'onKeyDown', 'onKeyUp', 'elementRef', 'itemRef', 'shouldCloseOnClick', 'withFocusOutline'];
export { propTypes, allowedProps, topNavBarItemTooltipPropType };